<div class="canvas-wrapper">
  <canvas #voiceCanvas width="500" height="300"></canvas>
</div>
